import { render, staticRenderFns } from "./OrganizationSettings.vue?vue&type=template&id=540f2eb0&"
import script from "./OrganizationSettings.vue?vue&type=script&lang=ts&"
export * from "./OrganizationSettings.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VContainer,VTab,VTabItem,VTabs,VTabsItems})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('540f2eb0')) {
      api.createRecord('540f2eb0', component.options)
    } else {
      api.reload('540f2eb0', component.options)
    }
    module.hot.accept("./OrganizationSettings.vue?vue&type=template&id=540f2eb0&", function () {
      api.rerender('540f2eb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OrganizationSettings.vue"
export default component.exports